var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4",attrs:{"id":"debug-container"}},[_c('MockNotificationBtn'),(_vm.loggedIn)?_c('MockLinkBtn'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }